import { convertEpochtoDate } from "../../../../helper/DateConverters";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import axios from "../../../../util/axiosconfig";
import { showError } from "../../../../util/ShowStatus";

export const fetchDashBoardData = async (
  setDashBoardData: any,
  setTotalTimeLogsCounts: any,
  setDashBoardDataLoading: any,
  filters: any,
  sortFilter: any,
  toast: any
) => {
  try {
    setDashBoardDataLoading(true);

    const response = await axios.get(
      `tl-admin/dashboard?startDate=${filters.startDate}&endDate=${filters.endDate}`
      //   `tl-admin/dashboard?startDate=${filters.startDate}&endDate=${filters.endDate}&sortOrder=${sortFilter.sortOrder === true ? "asc" : "desc"}`
    );
    setDashBoardData(response.data.result);
    setTotalTimeLogsCounts({
      totalPendingTimelogs: response.data.totalPendingTimelogs,
      totalSubmittedTimelogs: response.data.totalSubmittedTimelogs,
      totalManagerSubmittedTimeLogs:
        response.data.totalManagerSubmittedTimeLogs,
      totalApprovedByManagerTimeLogs:
        response.data.totalApprovedByManagerTimeLogs,
      totalRejectedByManagerTimeLogs:
        response.data.totalRejectedByManagerTimeLogs,
      totalRejectedTimeLogs: response.data.totalRejectedTimeLogs,
      totalApprovedTimelogs: response.data.totalApprovedTimelogs,
      totalMissingTimeLogs: response.data.totalMissingTimeLogs,
    });
    setDashBoardDataLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setDashBoardDataLoading(false);
    showError(errorMessage, toast);
  }
};

export const exportDashBoardTimeLogData = async (
  filters: any,
  setExportLoading: any,
  toast: any
) => {
  try {
    setExportLoading(true);
    const response = await axios.get(
      `tl-admin/export-dashboard-timelog?startDate=${filters.startDate}&endDate=${filters.endDate}`,
      {
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    const newDates: any = {};
    newDates.startDate = convertEpochtoDate(filters.startDate);
    newDates.endDate = convertEpochtoDate(filters.endDate);
    link.href = url;
    link.setAttribute(
      "download",
      `timelog_report_(${newDates.startDate}_${newDates.endDate}).xlsx`
    );
    document.body.appendChild(link);
    link.click();
    setExportLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setExportLoading(false);
    showError(errorMessage, toast);
  }
};

export const exportDashBoardLeavesData = async (
  filters: any,
  setExportLeavesLoading: any,
  toast: any
) => {
  try {
    setExportLeavesLoading(true);
    const response = await axios.get(
      `tl-admin/export-dashboard-leaves?startDate=${filters.startDate}&endDate=${filters.endDate}`,
      {
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    const newDates: any = {};
    newDates.startDate = convertEpochtoDate(filters.startDate);
    newDates.endDate = convertEpochtoDate(filters.endDate);
    link.href = url;
    link.setAttribute(
      "download",
      `leaves_report_(${newDates.startDate}_${newDates.endDate}).xlsx`
    );
    document.body.appendChild(link);
    link.click();
    setExportLeavesLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setExportLeavesLoading(false);
    showError(errorMessage, toast);
  }
};
